import {numUtil} from './num';

// 需要聚合的k线
const resolutionMap = {
  3: 1, // 3分钟
  120: 60, // 2h
  180: 60, // 3h
  360: 60, // 6h
  720: 60, // 12h TODO: 考虑 round time
};

export const klineUtil = {
  /**
   * 返回实际订阅的k线周期
   * @param resolution 分钟
   * @returns {number} 秒
   */
  convertResolution(resolution): number {
    return (resolutionMap[resolution] || resolution) * 60;
  },
  convertToBar(raw: ws.KlineItemRaw, tradePair: TradePair): KlineBar {
    const {pricePrecision} = tradePair;
    const priceScale = genPriceScale(tradePair);
    // DER-997
    //["timestamp", "interval", "last_close", "open", "high", "low", "close", "volume", "turnover", "symbol"]
    const open = raw[2] != 0 ? raw[2] : raw[3];
    return {
      close: calcNumber(Number(raw[6]), pricePrecision, priceScale),
      high: calcNumber(Number(raw[4]), pricePrecision, priceScale),
      low: calcNumber(Number(raw[5]), pricePrecision, priceScale),
      open: calcNumber(Number(open), pricePrecision, priceScale),
      time: raw[0] * 1e3,
      volume: calcVolume(Number(raw[7]), tradePair),
    };
  },
};

function genPriceScale(tradePair: TradePair) {
  return tradePair.type === 'Spot' ? (tradePair as SpotPair).quoteQtyScale : tradePair.priceScale;
}

function calcNumber(priceEp, pricePrecision, priceScale) {
  return Number(numUtil.floor(priceEp, pricePrecision, priceScale));
}

function calcVolume(volumeEv, tradePair: TradePair) {
  if (tradePair.type === 'Spot') {
    const {baseQtyPrecision, baseQtyScale} = tradePair as SpotPair;
    return calcNumber(volumeEv, baseQtyPrecision, baseQtyScale);
  }
  return volumeEv;
}
